import type { NumericInputProps } from '@library/components'
import type { Nullable } from '@library/types'
import type { FC } from 'react'

import { SimpleButton } from '../../SimpleButton'
import { SingleInput } from '../SingleInput'
import { SettingContainer } from './SettingContainer'
import css from './SettingContainer.css'

type SettingNumberWithToggleButtonProps = NumericInputProps & {
  min?: number
  max?: number
  toggleValue: boolean
  inputValue: Nullable<string>
  errorText?: string
  onToggle: VoidFunction
  icons: JSX.Element[]
}

export const SettingNumberWithToggleButton: FC<SettingNumberWithToggleButtonProps> = ({
  onToggle,
  inputValue,
  errorText,
  toggleValue,
  icons,
  onChange,
  onSetDefault,
  step,
  label,
  className,
  placeholder,
  status,
  mode,
  min,
  max,
}) => {
  const activeIcon = toggleValue ? icons[0] : icons[1]

  return (
    <SettingContainer label={label}>
      <div className={css.rowContainer}>
        <SingleInput
          className={className}
          placeholder={placeholder}
          status={status}
          value={inputValue}
          min={min}
          max={max}
          mode={mode}
          errorText={errorText}
          step={step}
          withClearButton={true}
          onChange={onChange}
          onSetDefault={onSetDefault}
        />
        <SimpleButton view="ghost" onClick={onToggle}>
          {activeIcon}
        </SimpleButton>
      </div>
    </SettingContainer>
  )
}
